module.exports = __webpack_public_path__ + "img/waistband width.596fd7f8.png";